import { createSessionMarker } from './sessionMarker'

const marker = createSessionMarker('core:bfcache-auth-reload', 10_000)

export const markBfcacheAuthReload = marker.mark

export const consumeBfcacheAuthReloadMarker = marker.consume

const cachedDocumentMarker = createSessionMarker('core:cached-document-auth-reload', 10_000)

export const claimCachedDocumentAuthReload = cachedDocumentMarker.claim

export const consumeCachedDocumentAuthReloadMarker = cachedDocumentMarker.consume
